"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import a from "../components/Icon/SvgIcon.js";
const r = (e) => /* @__PURE__ */ o(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.75 7a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0M11 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0M9.75 17a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0M11 17a4 4 0 1 1-8 0 4 4 0 0 1 8 0m6-7.25a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5M17 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m2.75 6a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0M21 17a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
        clipRule: "evenodd"
      }
    )
  }
), n = t(r);
export {
  n as ShopCategories,
  n as default
};
